/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2014-2015, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
'use strict';

angular.module('bulbApp.animationModule')
.animation('.bulb-fade-in', function() {
  return {
    addClass: function(element, className, done) {
            element.css('display','block');
      element.animate({
        opacity: 1
      }, done);
    },
    removeClass: function(element, className, done) {
      element.animate({
        opacity: 0
      }, function() {
                element.css('display', 'none');
        done();
            });
    }
  };
});
